/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import {
  DescriptionText,
  IconContainer,
  ScreenHeader,
} from "../../../CommonComponents";
import { DownloadIcon, ReloadIcon } from "../../../utils/icons";
import ChantPopConfirm from "../../../CommonComponents/ChantTooltip/ChantPopConfirm";
import { SearchOutlined } from "@ant-design/icons";
import { ConfigProvider, Table, Input, Select } from "antd";
import "./ParentAdminGroups.css";
import ChantContainer from "../../../CommonComponents/ChantContainer";

import useParentGroups from "./useParentGroups";

const ParentAdminGroups = () => {
  const {
    searchTerm,
    selectedCountry,
    filteredGroups,
    isLoading,
    refetch,
    uniqueCountries,
    totalCount,
    columns,
    handleDownloadCsv,
    setSearchTerm,
    setSelectedCountry,
    downloading,
  } = useParentGroups();

  return (
    <ChantContainer>
      <ScreenHeader
        title={"Groups"}
        elementCount={totalCount}
        actions={
          <div className="pa-groups-actions-buttons">
            <ChantPopConfirm
              title="Download all groups list?"
              onConfirm={handleDownloadCsv}
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
              trigger="click"
            >
              <IconContainer
                loading={downloading}
                icon={DownloadIcon}
                disabled={downloading || isLoading}
              />
            </ChantPopConfirm>

            <ChantPopConfirm
              title="Refresh Groups List?"
              onConfirm={() => refetch()}
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
            >
              <IconContainer
                loading={isLoading}
                icon={ReloadIcon}
                disabled={isLoading}
              />
            </ChantPopConfirm>
          </div>
        }
      />

      <div style={{ marginTop: "var(--screen-general-margin)" }}>
        <DescriptionText showBackground>
          <p>
            Below are all the children groups of the parent group. You can view
            the members of each group by clicking the Member Icon in the Action
            column.
          </p>
        </DescriptionText>
      </div>

      <div
        style={{
          marginTop: "var(--screen-general-margin)",
          backgroundColor: "var(--primary-white-background)",
          padding: "8px 12px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Input
          placeholder="Search Group Name"
          prefix={<SearchOutlined />}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          allowClear
          style={{
            width: window.screen.width > 500 ? "300px" : "100%",
            minWidth: "200px",
          }}
        />
        <Select
          placeholder="Filter by Country"
          value={selectedCountry}
          onChange={setSelectedCountry}
          allowClear
          showSearch
          optionFilterProp="label"
          style={{
            width: window.screen.width > 500 ? "250px" : "100%",
            minWidth: "200px",
          }}
          options={uniqueCountries}
        />
      </div>

      <div style={{ height: "50vh" }}>
        <ConfigProvider
          theme={{
            components: {
              Table: {
                headerBorderRadius: 0,
              },
            },
          }}
        >
          <Table
            bordered
            columns={columns}
            headerBorderRadius={0}
            loading={isLoading}
            dataSource={filteredGroups}
            sticky={{
              offsetHeader: 0,
              getContainer: () => document.body,
            }}
            scroll={{ x: "max-content" }}
            rowKey="id"
            bodyStyle={{
              fontSize: window.screen.width > 500 ? "18px" : "12px",
              backgroundColor: "#ffffff",
            }}
            pagination={{
              defaultPageSize: 100,
              showSizeChanger: true,
              pageSizeOptions: [10, 20, 50, 100],
              position: ["bottomLeft"],
            }}
          />
        </ConfigProvider>
      </div>
    </ChantContainer>
  );
};

export default ParentAdminGroups;
